import { useMemo } from 'react';
import { useClientSubscription } from './useClientSubscription';
import { isActive } from './isActive';

/**
 * Проверяет есть ли у текущего клиента действующая подписка
 * Возвращает undefined если данных нет.
 */
export const useHasActiveSubscription = () => {
  const { data } = useClientSubscription();
  return useMemo(() => {
    if (!data) {
      return;
    }
    return isActive(data);
  }, [data]);
};
